import React from 'react';
import { useReframe } from 'nike-re-framejs';

import i18n from '@i18n';
import { BetSelectionsTlv } from './BetSelections';
import { TipCell, TipRow, TipTable } from '../../NikeOneCommon';
import { tlvBetsByMatchId$ } from '@/nikeone/liveSubs';
import { mainBet$$, matchBetCount$$, matchStatus$$ } from 'nike-ui/src/components/turboLive/push/overview/hybrid-subs';
import { channelStatus$$ } from 'nike-ui/src/components/turboLive/push/channelStatus/subs';

export function MainBetTlv({ eventId, goToDetail }) {
    const { subscribe } = useReframe();
    const bet = subscribe(mainBet$$(eventId));
    if (!bet?.selections?.length) {
        return <EmptyMainBet eventId={eventId} goToDetail={goToDetail} data-atid="nikeone-empty-main-bet" />;
    }
    const channelStatus = subscribe(channelStatus$$(bet.channelId));
    return (
        <TipTable>
            <BetSelectionsTlv bet={bet} delayed={channelStatus === 'DELAYED'} tableSize={bet.selections?.length} />
        </TipTable>
    );
}

function EmptyMainBet({ eventId, goToDetail }) {
    const derefSub = useReframe();
    const hasMoreBets = derefSub(matchBetCount$$(eventId));
    const eventStatus = derefSub(matchStatus$$(eventId));
    const hasAnotherBets = derefSub(tlvBetsByMatchId$(eventId));
    return (
        <TipTable>
            <TipRow>
                <TipCell
                    onClick={goToDetail}
                    classes={{ disabled: !hasMoreBets }}
                    label={() => (
                        <span className="kurz nothing">
                            {eventStatus === 'SCHEDULED' && !hasMoreBets && !hasAnotherBets?.size
                                ? i18n('jsp.liveStavky.prehlad.betsavailablesoon')
                                : hasMoreBets
                                ? i18n('jsp.liveStavky.prehlad.nextoffer')
                                : i18n('jsp.liveStavky.prehlad.nobettingevents')}
                        </span>
                    )}
                />
            </TipRow>
        </TipTable>
    );
}
